import { render, staticRenderFns } from "./business-consulting.vue?vue&type=template&id=71e7d2ca&scoped=true&"
import script from "./business-consulting.vue?vue&type=script&lang=ts&"
export * from "./business-consulting.vue?vue&type=script&lang=ts&"
import style0 from "./business-consulting.vue?vue&type=style&index=0&id=71e7d2ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e7d2ca",
  null
  
)

export default component.exports